import type { IUserProfile } from '../redux/api/types'

export const isLocalPresenceCountry = (user: IUserProfile) => {
  const prohibitedCountries = process.env.REACT_APP_LOCAL_PRESENCE_PROHIBITED_COUNTRIES ? process.env.REACT_APP_LOCAL_PRESENCE_PROHIBITED_COUNTRIES.split(',') : []
  return user.countryCode === null || !prohibitedCountries.map(v => v.toLowerCase()).includes(user.countryCode.toLowerCase())
}
